module.exports = __webpack_public_path__ + "static/img/yuanxiao.53e8eab7.png";